import { render, staticRenderFns } from "./config-custom-prowlarr.vue?vue&type=template&id=8373d546&scoped=true&"
import script from "./config-custom-prowlarr.vue?vue&type=script&lang=js&"
export * from "./config-custom-prowlarr.vue?vue&type=script&lang=js&"
import style0 from "./config-custom-prowlarr.vue?vue&type=style&index=0&id=8373d546&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8373d546",
  null
  
)

export default component.exports